import axios from "axios";
import { ApiConfig } from '../constants/apiConfig';
import { studentHeaders } from './apiClient';
export const fetchNamaGuru = async () => {
  const pembimbingId = localStorage.getItem("guru_pembimbing_id");
  if (!pembimbingId) return null;

  try {
    const response = await axios.get(
      `${ApiConfig.baseUrl}/search-guru?query=`,
      {
        headers: {
          Accept: "application/json",
          ...studentHeaders(),
        },
      }
    );

    const data = response.data.data;
    const guru = data.find((item) => item.id === parseInt(pembimbingId));
    return guru ? guru.nama_guru : null;
  } catch (error) {
    console.error("Gagal mengambil data guru:", error);
    return null;
  }
};
